import {management} from '../../../..' //api
import {VolumeRepository} from '../../../infra/knex/repositories/volume'

import {GetFirstVolumeLogFromValveUseCase} from './getFirstVolumeLogFromValve'

export const getFirstVolumeLogFromValveUseCase=new GetFirstVolumeLogFromValveUseCase(new VolumeRepository(management))
